import { FilterGroup, type Filters, type StepProps } from '@/features/products/types';

export const getSteps = (filters: Filters[]): StepProps[] => {
  const steps: StepProps[] = [];
  const personas = filters.find((f) => f.group === FilterGroup.USER_PERSONA);
  if (personas) {
    steps.push({
      title: 'Who is the end-user of the solution?',
      content: 'We want to identify the end-user for the solution. Multiple users can be chosen.',
      group: FilterGroup.USER_PERSONA,
      options: personas.values.map(({ id, value }) => ({
        label: value,
        value: { id, group: FilterGroup.USER_PERSONA, value, isParent: false },
      })),
      values: [],
    });
  }

  const industry = filters.find((f) => f.group === FilterGroup.INDUSTRY);
  if (industry) {
    steps.push({
      title: 'What is your Industry?',
      content:
        'We have specific solutions for industries and we can find them more easily for you. Multiple industries can be chosen.',
      group: FilterGroup.INDUSTRY,
      options: industry.children?.map(({ id: parentId, label, values }) => ({
        id: parentId,
        label,
        value:
          values.length > 0
            ? {
                id: parentId,
                group: FilterGroup.INDUSTRY,
                value: label,
                isParent: true,
                values: values.map(({ id, value }) => ({
                  id,
                  group: FilterGroup.INDUSTRY_AREA,
                  value,
                  isParent: false,
                })),
              }
            : { id: parentId, group: FilterGroup.INDUSTRY, value: label, isParent: false },
      })),
      values: [],
    });
  }

  const benefits = filters.find((f) => f.group === FilterGroup.BENEFIT_GROUP);
  if (benefits) {
    steps.push({
      title: 'What are your main needs?',
      content:
        'Each solution can address a particular end-user need and knowing exactly what result you want to achieve will make it easier to select the solutions for you. Multiple needs can be chosen.',
      group: FilterGroup.BENEFIT_GROUP,
      groups: benefits.children?.map(({ label, values, id: parentId }) => ({
        id: parentId,
        group: label,
        options: values.map(({ id, value, tooltip }) => ({
          id,
          label: value,
          value: { id, group: FilterGroup.BENEFIT, value, isParent: false },
          tooltip,
        })),
      })),
      values: [],
    });
  }

  return [...steps];
};
